export const BasicTextEditorConfigs = {
  plugins:
    "preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion ",
  toolbar:
    "undo redo | accordion accordionremove | blocks fontfamily fontsize fontweights | bold italic underline strikethrough | align numlist bullist | link image | table media | lineheight outdent indent| forecolor backcolor removeformat | charmap emoticons | code fullscreen preview | save print | pagebreak anchor codesample | ltr rtl",
  fontFamilyFormats: `
        Sans Serif=sans-serif;
        Butler=Butler;
        Montserrat=Montserrat;
        Pelak=Pelak;
        Kalameh=Kalameh;
        Noto Kufi Arabic=Noto Kufi Arabic;
        Reem Kufi=Reem Kufi;
    `,
  contentStyle: `
    @font-face {
      font-family: "Avita";
      src: url("/fonts/Avita/avita.outline-black.otf") format("opentype");
    }

    @font-face {
      font-family: "Butler";
      src: url("/fonts/Butler/Butler_Bold.otf") format("opentype");
      font-weight: 700; /* Bold */
    }

    @font-face {
      font-family: "Butler";
      src: url("/fonts/Butler/Butler_ExtraBold.otf") format("opentype");
      font-weight: 800; /* Extra Bold */
    }

    @font-face {
      font-family: "Butler";
      src: url("/fonts/Butler/Butler_Light.otf") format("opentype");
      font-weight: 300; /* Light */
    }

    @font-face {
      font-family: "Butler";
      src: url("/fonts/Butler/Butler_Medium.otf") format("opentype");
      font-weight: 500; /* Medium */
    }

    @font-face {
      font-family: "Butler";
      src: url("/fonts/Butler/Butler_Regular.otf") format("opentype");
      font-weight: 400; /* Regular */
    }

    @font-face {
      font-family: "Butler";
      src: url("/fonts/Butler/Butler_Ultra_Light.otf") format("opentype");
      font-weight: 100; /* Ultra Light */
    }

    @font-face {
      font-family: "Montserrat";
      font-weight: 300; /* Light */
      src: url("/fonts/Montserrat/Montserrat-Light.ttf") format("trueType");
    }

    @font-face {
      font-family: "Montserrat";
      font-weight: 400; /* Regular */
      src: url("/fonts/Montserrat/Montserrat-Regular.ttf") format("trueType");
    }

    @font-face {
      font-family: "Montserrat";
      font-weight: 500; /* Medium */
      src: url("/fonts/Montserrat/Montserrat-Medium.ttf") format("trueType");
    }

    @font-face {
      font-family: "Montserrat";
      font-weight: 600; /* SemiBold */
      src: url("/fonts/Montserrat/Montserrat-SemiBold.ttf") format("trueType");
    }

    @font-face {
      font-family: "Montserrat";
      font-weight: 700; /* Bold */
      src: url("/fonts/Montserrat/Montserrat-Bold.ttf") format("trueType");
    }

    @font-face {
      font-family: "Montserrat";
      font-weight: 800; /* ExtraBold */
      src: url("/fonts/Montserrat/Montserrat-ExtraBold.ttf") format("trueType");
    }

    @font-face {
      font-family: "Montserrat";
      font-weight: 900; /* Black */
      src: url("/fonts/Montserrat/Montserrat-Black.ttf") format("trueType");
    }

    @font-face {
      font-family: "IranSans";
      font-weight: 700;
      src: url("/fonts/Iransans/IRANSansWeb_Bold.woff2") format("woff2");
    }

    @font-face {
      font-family: "Artin";
      font-weight: 700;
      src: url("/fonts/Artin/Artin-Bold.woff2") format("woff2");
    }

    @font-face {
      font-family: "Pelak";
      font-weight: 700;
      src: url("/fonts/Pelak/Pelak-Bold.woff2") format("woff2");
    }

    @font-face {
      font-family: "Vazir";
      src: url("/fonts/Vazir/Vazir.woff2") format("woff2");
    }

    @font-face {
      font-family: "Kalameh";
      src: url("/fonts/Kalameh/KalamehWeb-Light.woff2") format("woff2");
    }

    @import url("https://fonts.googleapis.com/css2?family=Reem+Kufi:wght@400..700&display=swap");

    @import url("https://fonts.googleapis.com/css2?family=Noto+Kufi+Arabic:wght@100..900&family=Reem+Kufi:wght@400..700&display=swap");
  `,
};
